// Máquina de estados do chat: o que a interface mostra depois de cada clique (porte do fluxo do portal).
// Pura: devolve o novo estado e os efeitos que a tela executa (mensagem, feedback, compactar, encerrar, vídeo, chamado).
export const inicial = {
  fase: "livre",
  origem: null,
  artigos: [],
  falhas: 0,
  perguntar: false,
  duvida: false,
  // A resposta foi o passo a passo em cards: "Não" manda o vídeo (se houver) e depois abre o chamado.
  cartoes: false,
  video: null,
};
export const TEXTOS = {
  resolveu: "Resolvi seu problema?",
  entendeu: "Conseguiu entender?",
  soIsso: "É só isso. Conseguiu entender?",
  video: "Aqui vai um vídeo falando sobre o assunto. Assista com calma e me diz se conseguiu entender melhor.",
  confuso: "O que ficou confuso? Pode me contar com suas palavras.",
  contarMais: "Me conte mais sobre! Como está o problema - algo mudou, e você conseguiu seguir o que falei?",
  tchau: "Que bom! Consigo ajudar em mais alguma coisa? É só me contar.",
};
/** Depois de tantos "não" na IA, a conversa vira chamado. */
export const LIMITE_FALHAS = 2;
const esgotar = (f, antes = []) => ({ fluxo: { ...f, fase: "encaminhada" }, efeitos: [...antes, { e: "esgotou" }] });
const pergunta = (f) => ({ e: "bot", texto: f.cartoes ? TEXTOS.soIsso : f.duvida ? TEXTOS.entendeu : TEXTOS.resolveu });
export function passar(f, ev) {
  const igual = { fluxo: f, efeitos: [] };
  switch (ev.t) {
    case "entrega": {
      const base = {
        ...f,
        origem: ev.origem,
        artigos: ev.artigos ?? [],
        perguntar: !!ev.resolvivel,
        duvida: !!ev.duvida,
        cartoes: !!ev.cartoes,
        video: ev.video ?? null,
      };
      if (ev.resolvivel) return { fluxo: { ...base, fase: "resolveu" }, efeitos: [pergunta(base)] };
      return { fluxo: { ...base, fase: "livre" }, efeitos: [] };
    }
    case "sim":
      // Entendeu/resolveu: agradece e segue; o chat continua livre (só o chamado encerra).
      if (f.fase === "resolveu" || f.fase === "video") {
        return {
          // O documento sai do contexto: só o prompt base e o resumo continuam.
          fluxo: { ...f, fase: "livre", origem: null, artigos: [], video: null, cartoes: false, duvida: false },
          efeitos: [
            { e: "feedback", positivo: true, origem: f.origem, artigos: f.artigos },
            { e: "bot", texto: TEXTOS.tchau },
            { e: "compactar" },
          ],
        };
      }
      return igual;
    case "nao":
      if (f.fase !== "resolveu") return igual;
      {
        const negativo = { e: "feedback", positivo: false, origem: f.origem, artigos: f.artigos };
        // Passo a passo em cards: primeiro o vídeo (se houver), depois a equipe.
        if (f.cartoes) {
          if (!f.video) return esgotar(f, [negativo]);
          return { fluxo: { ...f, fase: "video" }, efeitos: [negativo, { e: "bot", texto: TEXTOS.video }, { e: "video" }] };
        }
        if (f.falhas + 1 >= LIMITE_FALHAS) return esgotar(f, [negativo]);
        return {
          fluxo: { ...f, fase: "explicar", falhas: f.falhas + 1 },
          efeitos: [negativo, { e: "bot", texto: f.duvida ? TEXTOS.confuso : TEXTOS.contarMais }],
        };
      }
    case "ainda":
      return f.fase === "video" ? esgotar(f) : igual;
    case "semSolucao":
      return f.fase === "encerrada" || f.fase === "encaminhada" ? igual : esgotar(f);
    default:
      return igual;
  }
}

